import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useTestimonialsList() {
    // Use toast
    const toast = useToast();

    const refTestimonialListTable = ref(null);

    // Table Handlers
    // Alineación estándar de las tablas del panel (mismo patrón que revisiones-admin):
    // `...styleTable` centra cabecera y contenido; `thClass: styleTable.thClass`
    // centra solo la cabecera y deja el contenido a la izquierda.
    const styleTable = {
        thClass: 'text-center',
        tdClass: 'text-center'
    };

    let tableColumns = [
        { key: 'testimonial_order', sortable: true, label: 'Orden', ...styleTable },
        { key: 'display_name', sortable: false, label: 'Nombre público', thClass: styleTable.thClass },
        { key: 'is_anonymous', sortable: true, label: 'Anónimo', ...styleTable },
        { key: 'score', sortable: true, label: 'Puntaje', ...styleTable },
        { key: 'comments', sortable: false, label: 'Comentario', thClass: styleTable.thClass },
        { key: 'completion_date', sortable: true, label: 'Fecha registro', labelHtml: 'Fecha <br> registro', ...styleTable },
        { key: 'testimonial_active', sortable: true, label: 'Estado', ...styleTable },
        { key: 'actions', sortable: false, label: 'Opciones', ...styleTable }
    ];

    const perPage = ref(10);
    const totalTestimonials = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('');
    const isSortDirDesc = ref(false);

    const dataMeta = computed(() => {
        const localItemsCount = refTestimonialListTable.value ? refTestimonialListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalTestimonials.value,
        }
    });

    const refetchData = () => {
        refTestimonialListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
    });

    const fetchTestimonials = (ctx, callback) => {
        store
            .dispatch('app-testimonial/fetchTestimonials', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value
            })
            .then(response => {
                const { testimonials, total } = response.data;
                callback(testimonials);
                totalTestimonials.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de testimonios',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchTestimonials,
        tableColumns,
        perPage,
        currentPage,
        totalTestimonials,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTestimonialListTable,

        refetchData
    }
}
